import {environment} from '../../environments/environment';

let lang;


export const center = environment.center || [0, 0];
export const zoom = environment.zoom || 10;
export const citylogo = environment.citylogo;
export const citylogoMobile = environment.citylogoMobile;
export const cityName = environment.city;
export const applicationLogo = environment.applicationLogo;
export const loginApplicationLogo = environment.loginApplicationLogo;
export const theme = environment.theme;
export const showGeographica = environment.showGeographica;

export function setLang (l) {
  lang = l;
}

export function getLang () {
  return lang;
}

export let CITY = 'CITY';

export const _defaultlivetypes = [
  {
    id: 1,
    idText: 'JAM',
    name: 'Jams',
    icon: 'jam.svg',
    groupBy: 'level',
    showing: true
  }, {
    id: 0,
    idText: 'ACCIDENT',
    name: 'Accidents',
    icon: 'accident.svg',
    groupBy: 'subtype',
    showing: true
  }, {
    id: 2,
    idText: 'WEATHERHAZARD',
    name: 'WEATHERHAZARD',
    icon: 'hazard.svg',
    groupBy: 'subtype',
    showing: true
  }, {
    id: 4,
    idText: 'CONSTRUCTION',
    name: 'Construction',
    icon: 'construction.svg',
    groupBy: 'type',
    showing: true
  }, {
    id: 5,
    idText: 'ROAD_CLOSED',
    name: 'Road closed',
    icon: 'road_closed.svg',
    groupBy: 'subtype',
    showing: true
  }, {
    id: 3,
    idText: 'MISC',
    name: 'Misc',
    icon: 'misc.svg',
    groupBy: 'type',
    showing: true
  }, {
    id: 7,
    idText: 'EVENT',
    name: 'Events',
    icon: 'event.svg',
    groupBy: 'type',
    showing: true
  }
];

export const _defaultupcomingtypes = [
  {
    id: 8,
    idText: 'PREVISION',
    name: 'Prevision',
    icon: 'prevision.svg',
    source: 'council',
    groupBy: 'status',
    showing: true
  }
];

export const _defaultCity = [
  {
    mode: 'live',
    modeName: 'Live',
    active: true,
    sources: [{
      id: 'waze',
      name: 'Waze',
      showing: true,
      numberOfElements: 0,
    }],
    types: _defaultlivetypes
  }
];

export const Colors = {
  'colorPrimary': '#8CE0EA',
  'colorPrimaryDark': '#4AA5BA',
  'colorAccent': '#BEDCE5',
  'colorSecondary': '#FF6D66',
  'colorAccentAlt': '#FFA7A3',
  'colorPrimaryLight': '#93C4D3',
  'colorPrimaryLight2': '#162745',
  'colorN100': '#1A1E29',
  'colorN90': '#292D3A',
  'colorN80': '#383D4C',
  'colorN70': '#4B505F',
  'colorN60': '#626775',
  'colorN50': '#787D8B',
  'colorN40': '#9397A2',
  'colorN30': '#AEB1B9',
  'colorN20': '#C9CBD1',
  'colorN10': '#E4E5E8',
  'colorN05': '#F2F2F4',
  'colorWhite': '#FFF',
  'level1': '#F9CC7D',
  'level2': '#F9AA6E',
  'level3': '#F8895F',
  'level4': '#F86750',
  'level5': '#F74541',
  'levelAlert1': '#F9CC7D',
  'levelAlert2': '#F8895F',
  'levelAlert3': '#F74541',
  'fluid': '#8DD99B',
  'closed': '#af1811',
  'nodata': '#B55CA4',
  'alertLow': '#F9CC7D',
  'alertMedium': '#F8895F',
  'alertHigh': '#F74541',
  'yellow': '#FFE166',
  'distrinctLow': '#8DD99B',
  'distrinctMedium': '#FFB76E',
  'distrinctHigh': '#FB837D'
};

export const ServiceLevelColor = {
  'NODATA': Colors.nodata,
  'SLOW': Colors.level2,
  'HOLD': Colors.level3,
  'CONGESTION': Colors.level5,
  'CLOSED': Colors.closed,
  'FLUID': Colors.fluid,
  'POOR': Colors.level5,
  'GOOD': Colors.fluid,
  'FAIR': Colors.level2
};

export const DistrictRealTimeZoom = 11;

export enum Types {
  ACCIDENT,
  JAM,
  HAZARD,
  MISC,
  CONSTRUCTION,
  ROAD_CLOSED,
  IRREGULARITIES,
  EVENT,
  PREVISION,
  SERVICE_LEVELS
};

export enum Subtypes {
  UNCATEGORIZED
};

export enum Mode {
  REALTIME,
  UPCOMING
};

export enum Source {
  WAZE,
  MADRID,
  SANDIEGO
};

export function alertsLevel (type, subtype) {
  let levels;

  switch (type) {
    case Types.ACCIDENT:
      levels = _getAccidentsLevels();
      break;
    case Types.JAM:
      levels = _getJamsLevels();
      break;
    case Types.HAZARD:
      levels = _getHazardLevels();
      break;
    case Types.MISC:
      return null;
    case Types.CONSTRUCTION:
      return null;
    case Types.ROAD_CLOSED:
      levels = _getRoadClosedLevels();
      break;
  }
  let result = null;
  if (levels) {
    Object.keys(levels).forEach(key => {
      if (levels[key].indexOf(subtype) >= 0) {
          result = key;
      }
    });
  }
  return result;

}

function _getAccidentsLevels () {
  return {
    low: ['ACCIDENT_MINOR'],
    high: ['ACCIDENT_MAJOR']
  };
}

function _getJamsLevels() {
  return {
    low: ['JAM_LIGHT_TRAFFIC'],
    medium: ['JAM_MODERATE_TRAFFIC'],
    high: ['JAM_HEAVY_TRAFFIC', 'JAM_STAND_STILL_TRAFFIC']
  };
}

function _getHazardLevels () {
  return {
    low: ['HAZARD_WEATHER_HEAT_WAVE', 'HAZARD_ON_SHOULDER_MISSING_SIGN',
    'HAZARD_ON_SHOULDER_ANIMALS', 'HAZARD_ON_SHOULDER_CAR_STOPPED',
    'HAZARD_ON_ROAD_POT_HOLE', 'HAZARD_ON_ROAD_OBJECT', 'HAZARD_ON_ROAD_OBJECT', 'HAZARD_ON_SHOULDER', 'HAZARD_ON_ROAD'],
    medium: ['HAZARD_ON_ROAD_CONSTRUCTION', 'HAZARD_ON_ROAD_ICE', 'HAZARD_ON_ROAD_OIL', 'HAZARD_ON_ROAD_LANE_CLOSED',
    'HAZARD_WEATHER_FREEZING_RAIN', 'HAZARD_WEATHER_HAIL', 'HAZARD_WEATHER_FOG'],
    high: ['HAZARD_ON_ROAD_CAR_STOPPED', 'HAZARD_WEATHER_HURRICANE', 'HAZARD_WEATHER_TORNADO', 'HAZARD_WEATHER_MONSOON',
    'HAZARD_WEATHER_FLOOD', 'HAZARD_WEATHER_HEAVY_SNOW', 'HAZARD_WEATHER_HEAVY_RAIN', 'HAZARD_ON_ROAD_ROAD_KILL']
  };
}

function _getRoadClosedLevels() {
  return {
    low: ['ROAD_CLOSED_EVENT'],
    medium: ['ROAD_CLOSED_CONSTRUCTION'],
    high: ['ROAD_CLOSED_HAZARD']
  };
}




// WEBPACK FOOTER //
// ./src/app/common/const.ts